import { render, staticRenderFns } from "./tab-buttons.vue?vue&type=template&id=53aad88a&scoped=true"
import script from "./tab-buttons.vue?vue&type=script&lang=js"
export * from "./tab-buttons.vue?vue&type=script&lang=js"
import style0 from "./tab-buttons.vue?vue&type=style&index=0&id=53aad88a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aad88a",
  null
  
)

export default component.exports